import * as React from 'react';
import { MouseEvent } from 'react';
import { Button } from '@origin-digital/style-guide';
import { PasswordComponent } from './PasswordComponent/PasswordComponent';
import { AuthCard } from '../../../../components/Card';
import { Heading } from '../../../../components/Heading';
import { InfoText } from '../../../../components/InfoText';
import PasswordTeddyBear from 'images/password_teddy.svg';
import { HiddenAutofillInput } from 'ts/login/components/HiddenAutofillInput/HiddenAutofillInput';
import { Alert } from 'ts/components/Alert';
import { Page } from '../../../../components/Page';

interface SetYourPasswordViewProps {
  onDoneClick: (event: MouseEvent<HTMLButtonElement>) => void;
  onPasswordChanged: (event) => void;
  password: string;
  username: string;
  showPasswordErrorMessage: boolean;
  spinner: boolean;
  alertBoxErrorMessage: string;
}

const SetYourPasswordView: React.FC<SetYourPasswordViewProps> = ({
  onDoneClick,
  onPasswordChanged,
  password,
  showPasswordErrorMessage,
  username,
  spinner,
  alertBoxErrorMessage,
}) => (
  <Page>
    <AuthCard image={PasswordTeddyBear}>
      <>
        <Heading text="One last thing..." />
        <InfoText text={`Your username is __${username}__ – now set yourself a password`} />
        {alertBoxErrorMessage && <Alert text={alertBoxErrorMessage} />}
        <form>
          {/* Input for autofill to populate username */}
          <HiddenAutofillInput username={username} />
          <PasswordComponent
            password={password}
            onPasswordChanged={onPasswordChanged}
            showPasswordErrorMessage={showPasswordErrorMessage}
          />
          <Button
            text="Continue"
            type="submit"
            onClick={onDoneClick}
            data-id="save-password-button"
            block={true}
            spinner={spinner}
          />
        </form>
      </>
    </AuthCard>
  </Page>
);

export { SetYourPasswordView };
